module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    attrs: {
      "for": "storage-amount"
    }
  }, [_vm._v(_vm._s(_vm.inputLabel))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "type": "text",
      "id": "storage-amount",
      "readonly": _vm.editable === false
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setText
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17263ea9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/TextInput.vue
// module id = 1400
// module chunks = 1